// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, {FC} from "react";

type componentProps = {
  id?:string
} & {[key:string]:any}; // string | boolean | number | React.ReactNode

const BrE:FC<componentProps> = (props) => (<br {...props} />);

export default BrE;
